import { render, staticRenderFns } from "./Comment.vue?vue&type=template&id=77d8757e&scoped=true"
import script from "./Comment.vue?vue&type=script&lang=js"
export * from "./Comment.vue?vue&type=script&lang=js"
import style0 from "./Comment.vue?vue&type=style&index=0&id=77d8757e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77d8757e",
  null
  
)

export default component.exports